export default __webpack_public_path__ + "static/media/profile-user.ba1e4238.svg";